export const receiptsOptions = [
  { value: 1, label: 'Draft' },
  { value: 2, label: 'Posted' },
  { value: 3, label: 'Canceled' },
]

export const receiptQcResultOptions = [
  { value: 1, label: 'Pass' },
  { value: 2, label: 'Pending' },
  { value: 3, label: 'Rejected' },
]
